module.exports = __webpack_public_path__ + "static/media/never-bnb.71aef6b0.svg";